<template>
  <div style="width: 100%">
    <!-- 右侧登录用户组件 -->
    <div style="display:flex; flex-wrap: wrap">
      <div class="header-left">
        <navbar-tab :websiteType="websiteType"></navbar-tab>
      </div>
      <div class="usercon" style="margin-left: auto">
        <div class="user--Con">
          <!--告警图标嵌套内容-->

          <!--个人中心嵌套内容-->
          <el-popover placement="bottom" v-model="visible2" style="display: inline-block;">
            <p class="headertext" @click="centerDialogVisibles = true" v-if="Permission.indexOf(28) != -1">
              <i class="icon-yonghu1"></i>{{ $t("lang.user.Personal") }}
            </p>
            <p class="headertext" @click="modificationpassword" v-if="Permission.indexOf(148) != -1">
              <i class="el-icon-edit"></i>{{ $t("lang.user.ChangePassword") }}
            </p>
            <p class="headertext" @click="ShowEmail" v-if="Permission.indexOf(176) != -1">
              <i class="icon-youxiang"></i>{{ $t("lang.user.EmailBinding") }}
            </p>
            <p class="headertext" @click="remcookie">
              <i class="icon-tuichu"></i>{{ $t("lang.user.exit") }}
            </p>
            <div slot="reference" class="curso">
              <img :src="user.user_icon" class="userimg" v-if="user.user_icon" />
              <img :src="userimg" class="userimg" v-if="!user.user_icon" />
              <span style="margin-left: 2px;color: skyblue;cursor: pointer;">{{
                user.username
              }}</span>
              <i class="el-icon-caret-bottom" style="font-size: 0.2rem;"></i>
            </div>
          </el-popover>
          <i class="icon-quanping Qp-Icon" @click="buttoncli"></i>
          <!-- 语言切换 -->
          <el-dropdown trigger="click" style="margin-left:20px;" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ LanguageValue.label
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <div v-for="(item, index) in LanguageList" :key="index">
                <el-dropdown-item :command="item">{{
                  item.label
                }}</el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!--修改密码弹出层-->
    <el-dialog :title="$t('lang.user.ChangePassword')" :visible.sync="centerDialogVisible" width="25%" center>
      <p style="text-align: center">
        <span class="tetxp">{{ $t("lang.user.OldPassword") }}：</span>
        <el-input size="mini" class="passwordinput" v-model="newpass.oldpassword"></el-input>
      </p>
      <p style="text-align: center">
        <span class="tetxp">{{ $t("lang.user.NewPassword") }}：</span>
        <el-input size="mini" class="passwordinput" v-model="newpass.newpassword"></el-input>
      </p>
      <p style="text-align: center">
        <span class="tetxp">{{ $t("lang.user.Confirm") }}：</span>
        <el-input size="mini" class="passwordinput" v-model="newpass.affirmpassword"></el-input>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">{{
          $t("lang.user.cancel")
        }}</el-button>
        <span> </span>
        <el-button type="primary" @click="submitpassword">{{
          $t("lang.user.Confirmation")
        }}</el-button>
      </span>
    </el-dialog>
    <!--个人资料弹出层-->
    <el-dialog :title="$t('lang.user.Personal')" :visible.sync="centerDialogVisibles" width="30%" center>
      <img :src="user.user_icon" class="useravatar" v-if="user.user_icon" />
      <img src="../../../assets/useravatar.svg" class="useravatar" v-if="!user.user_icon" />
      <br />
      <p class="userlabel">{{ $t("lang.user.User") }}：</p>
      <span class="userlabel-text">{{ user.username }}</span>
      <br />
      <p class="userlabel">{{ $t("lang.user.Email") }}：</p>
      <span class="userlabel-text">{{ user.user_email }}</span>
      <br />
      <p class="userlabel">{{ $t("lang.user.NICKNAME_RE") }}：</p>
      <span v-if="edac === false" class="userlabel-text">{{
        user.nickname
      }}</span>
      <el-input size="mini" v-if="edac === true" v-model="user.nickname" class="upinput"></el-input>
      <br />
      <p class="userlabel">{{ $t("lang.user.UserRelated") }}：</p>
      <span v-if="edac === false" class="userlabel-text">{{
        user.realname
      }}</span>
      <el-input size="mini" v-if="edac === true" v-model="user.realname" class="upinput"></el-input>
      <!-- <br> -->
      <!-- <p class="userlabel">{{$t('lang.user.Gender')}}：</p>
      <el-radio-group v-model="user.user_sex" v-if="edac===false">
          <el-radio :label="'0'" disabled>{{$t('lang.user.Male')}}</el-radio>
          <el-radio :label="'1'" disabled>{{$t('lang.user.Female')}}</el-radio>
      </el-radio-group> -->
      <!-- <el-radio-group v-model="user.user_sex" v-if="edac===true">
          <el-radio :label="'0'">{{$t('lang.user.Male')}}</el-radio>
          <el-radio :label="'1'">{{$t('lang.user.Female')}}</el-radio>
      </el-radio-group> -->
      <br />
      <p class="userlabel">{{ $t("lang.user.Phones") }}：</p>
      <span v-if="edac === false" class="userlabel-text">{{
        user.user_tel
      }}</span>
      <el-input size="mini" v-if="edac === true" v-model="user.user_tel" class="upinput"></el-input>
      <br />
      <p class="userlabel">{{ $t("lang.user.social") }}：</p>
      <span v-if="edac === false" class="userlabel-text">{{
        user.user_qq
      }}</span>
      <el-input size="mini" v-if="edac === true" v-model="user.user_qq" class="upinput"></el-input>
      <br />
      <p class="userlabel">{{ $t("lang.user.software") }}：</p>
      <span v-if="edac === false" class="userlabel-text">{{
        user.user_addr
      }}</span>
      <el-input size="mini" v-if="edac === true" v-model="user.user_addr" class="upinput"></el-input>
      <br />
      <p class="userlabel">{{ $t("lang.user.recently") }}：</p>
      <span class="userlabel-text">{{ user.userLoginTime }}</span>
      <br />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="edac = true" v-show="edac === false" v-if="Permission.indexOf(21) != -1">{{
          $t("lang.user.modify") }}</el-button>
        <el-button type="success" @click="setuser" v-show="edac === true">{{
          $t("lang.user.badconfirmstr")
        }}</el-button>
      </span>
    </el-dialog>
    <!--绑定邮箱弹出层-->
    <el-dialog :title="$t('lang.user.EmailBinding')" :visible.sync="EmailVisible" width="30%" center>
      <p style="text-align: center">
        <span class="tetxp">{{ $t("lang.user.EmailAddress") }}：</span>
        <el-input size="mini" class="passwordinput" v-model="Email.EmailAddress"></el-input>
      </p>
      <p style="text-align: center">
        <span class="tetxp">{{ $t("lang.user.VerifyPassword") }}：</span>
        <el-input size="mini" class="passwordinput" type="password" v-model="Email.password"></el-input>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="EmailVisible = false">
          {{ $t("lang.user.cancel") }}</el-button>
        <el-button type="primary" @click="BindEmail">{{
          $t("lang.user.Confirmation")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  removeToken,
  removeMenu,
  getPermission,
  removePermission,
} from "../../../cookie/cookie";
import { mapActions, mapGetters } from "vuex";
import {
  changePassword,
  getUserDetails,
  updateUser,
  userLogout,
  bindEmail,
} from "@/api/navbar";
import screenfull from "screenfull";
import breadcrumb from "./Breadcrumb";
import navbarTab from "./navbarTab";
import { SetLan, GetLan, SetMonitor } from "@/localStorage/localStorage";
export default {
  props: ["websiteType"],
  data() {
    return {
      //权限
      Permission: [],
      //告警信息隐藏块
      visible1: false,
      visible3: false,
      //个人中心隐藏块
      visible2: false,
      //修改密码弹出层
      centerDialogVisible: false,
      //绑定邮箱弹出层
      EmailVisible: false,
      newpass: {
        newpassword: "",
        affirmpassword: "",
        oldpassword: "",
      },
      //个人资料弹出层
      centerDialogVisibles: false,
      user: {},
      edac: false,
      tabicon: 1,
      tab: null,
      userimg: "",
      //全屏控制
      isFullscreen: false,
      //语言列表
      LanguageList: [
        { label: "繁體中文", value: "zh-TW" },
        { label: "简体中文", value: "zh-CN" },
        { label: "English", value: "en-US" },
      ],
      LanguageValue: {
        label: GetLan() == null || (()=>{if(GetLan()=='zh-TW'){return '繁體中文'}else if(GetLan()=='zh-CN'){return '简体中文'}else{return 'English'}})(),
        value: GetLan(),
      },
      //邮箱绑定
      Email: {
        EmailAddress: "",
        password: "",
      },
    };
  },
  created() {
    if (GetLan() == "zh-CN") {
      this.$set(this.LanguageValue, "label", `简体中文`);
      this.$set(this.LanguageValue, "value", "zh-CN");
    }else if(GetLan() == "zh-TW") {
      this.$set(this.LanguageValue, "label", `繁體中文`);
      this.$set(this.LanguageValue, "value", "zh-TW");
    }else {
      this.$set(this.LanguageValue, "label", "English");
      this.$set(this.LanguageValue, "value", "en-US");
    }
  },
  methods: {
    ...mapActions(["ShowNav", "GetLanguage", "GetLogo"]),
    //返回首页
    handleHome() {
      this.visible2 = false;
      this.$router.push({ path: "/dashboard" });
    },
    //退出登录，删除cookie值
    remcookie() {
      userLogout()
        .then((res) => {
          if (res.data.code == 0) {
            this.visible2 = false;
            removeToken();
            removeMenu();
            removePermission();
            this.$store.dispatch("ClearDefault");
            let language = window.localStorage.getItem("I18n");
            window.localStorage.clear();
            window.localStorage.setItem("I18n", language);
            this.$nextTick(() => {
              this.$router.push({ path: "/login" });
            });
          }
        })
        .catch(() => { });
    },
    //修改密码弹出层
    modificationpassword() {
      this.centerDialogVisible = !this.centerDialogVisible;
    },
    //绑定邮箱弹出层
    ShowEmail() {
      //清空
      this.Email = {
        EmailAddress: "",
        password: "",
      };
      this.EmailVisible = !this.EmailVisible;
    },
    //绑定邮箱请求
    BindEmail() {
      if (
        !/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(
          this.Email.EmailAddress
        )
      ) {
        this.$message({
          showClose: true,
          message: this.$t("lang.dashboard.emailError"),
          type: "warning",
        });
      }
      bindEmail(this.Email.EmailAddress, this.Email.password).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.dashboard.activateTips"),
            type: "success",
          });
          this.EmailVisible = false;
        } else if (res.data.code === 15) {
          this.$message({
            showClose: true,
            message: this.$t("lang.dashboard.userPWDError"),
            type: "warning",
          });
        }
      });
    },
    submitpassword() {
      let password = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,16}$/;
      if (this.newpass.affirmpassword !== this.newpass.newpassword) {
        this.$message({
          showClose: true,
          message: this.$t("lang.dashboard.message1"),
          type: "warning",
        });
        return;
      } else if (password.test(this.newpass.newpassword) != true) {
        this.$message({
          showClose: true,
          message: this.$t("lang.dashboard.message2"),
          type: "warning",
        });
        return;
      } else if (password.test(this.newpass.oldpassword) != true) {
        this.$message({
          showClose: true,
          message: this.$t("lang.dashboard.message2"),
          type: "warning",
        });
        return;
      }
      changePassword(this.newpass.newpassword, this.newpass.oldpassword).then(
        (res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: this.$t("lang.dashboard.message3"),
              type: "success",
            });
            this.centerDialogVisible = !this.centerDialogVisible;
          } else if (res.data.code === 15) {
            this.$message({
              showClose: true,
              message: this.$t("lang.dashboard.oldPWDError"),
              type: "warning",
            });
          }
        }
      );
    },
    //获取用户详细资料
    getUserDetails() {
      getUserDetails().then((res) => {
        this.user = res.data.data;
        this.$emit("getcopyRight", res.data.data.copyRight);
        this.$store.dispatch("GetLogo", res.data.data.customerLogo || require('@/assets/logo.png'));
        this.$store.dispatch("GetDefaultGroupId", res.data.data.defaultGroupId);
      });
    },
    //修改用户详细资料
    setuser() {
      updateUser(this.user).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.dashboard.message3"),
            type: "success",
          });
          this.edac = false;
          this.getUserDetails();
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.dashboard.message4"),
            type: "warning",
          });
        }
      });
    },
    buttoncli() {
      if (!screenfull.enabled) {
        // 如果不允许进入全屏，发出不允许提示
        this.$message({
          message: this.$t("lang.dashboard.message5"),
          type: "warning",
        });
        return false;
      }
      screenfull.toggle();
    },
    //切换语言
    handleCommand(command) {
      SetLan(command.value);
      location.reload();
    },
  },
  mounted() {
    this.getUserDetails();
    this.Permission = getPermission();
    //异步填充图片
    this.$nextTick(() => {
      this.userimg = require("../../../assets/useravatar.svg");
    });
  },
  computed: {
    ...mapGetters(["NavShow"]),
  },
  components: {
    breadcrumb,
    navbarTab,
  },
};
</script>

<style scoped>
.con {
  background-color: #ffffff;
  width: 100%;
  height: 54px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12),
    0 0 3px 0 rgba(0, 0, 0, 0.04);
  overflow: hidden;
  position: fixed;
  z-index: 100;
}

.but {
  font-size: 20px;
  /*margin-left: 20px;*/
  /* line-height: 10vh; */
  /* gai de */
  line-height: 8vh;
  color: #ffffff;
  cursor: pointer;
}

.usercon {
  /* float: right; */
  /* margin: 1.8vh 0.3rem 0rem 0rem; */
  /* margin: 1vh 0.3rem 0rem 0rem; */
  display: flex;
  align-self: center;
}

.user--Con {
  border: 1px solid #eaeaea;
  border-radius: 25px;
  padding: 5px 40px;
  background-color: #ffffff;
  /* height: 40px; */

  display: flex;
  justify-content: center;
  align-items: center;
}

.userimg {
  /* width: 35px;
    height: 35px; */
  width: 30px;
  height: 30px;
  border-radius: 35px;
  margin-bottom: 2.5px;
}

.bul {
  text-align: center;
}

.title {
  font-size: 15px;
  font-weight: bold;
  line-height: 54px;
  display: inline-block;
  margin-left: 1.18rem;
}

.el-popover {
  padding: 0 !important;
}

.el-button {
  margin-left: auto;
}

.icon-gaojin {
  line-height: 15px;
  font-size: 20px;
}

.curso {
  cursor: pointer;
  outline: none;
}

.headertext {
  text-align: center;
  cursor: pointer;
  margin: 0.1rem 0rem;
  padding: 0.1rem;
}

.headertext i {
  margin-right: 5px;
}

.headertext:hover {
  background-color: #409eff;
  color: #ffffff;
}

.tetxp {
  display: inline-block;
  width: 2.5rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}

.passwordinput {
  width: 4rem;
}

.useravatar {
  display: block;
  margin: 0 auto;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
}

.userlabel {
  width: 40%;
  text-align: right;
  display: inline-block;
  margin: 0.2rem 0rem;
  font-size: 0.25rem;
}

.upinput {
  display: inline-block;
  width: 3rem;
}

.userlabel-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.25rem;
}

.icon-shangjiantou1 {
  display: block;
  width: 10px;
  height: 10px;
  font-size: 10px !important;
  padding: 0 !important;
  color: rgb(158, 158, 158);
}

.icon-xiajiantou1 {
  display: block;
  width: 10px;
  height: 10px;
  font-size: 10px !important;
  padding: 0 !important;
  color: rgb(158, 158, 158);
}

.iconcolor {
  color: #409eff;
}

.Qp-Icon {
  line-height: 40px;
  font-size: 20px;
  margin-left: 20px;
}
</style>
